<template>
  <v-carousel hide-delimiters cycle>
    <v-carousel-item
      v-for="(item, i) in banners"
      :key="i"
      :src="getURL(item)"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
import { getURL } from "../../assets/js/common";
export default {
  computed: {
    dashboard() {
      return this.$store.getters.dashboard;
    },
    banners() {
      let { Banner } = this.dashboard;
      return Banner instanceof Array ? Banner : [];
    },
  },
  methods: {
    getURL({ Image_Path }) {
      return getURL(Image_Path);
    },
  },
};
</script>

<style>
</style>